module.exports = __webpack_public_path__ + "img/cepheus.269ce984.png";